import { SharedResource } from "@fartherfinance/frontend/api/Sharing/Types";
import {
  TransitionProposalHoldingsFilterResponse,
  TransitionProposalsImportTypeKey,
} from "@fartherfinance/frontend/api/TransitionProposals/types";

import { TextColor } from "@src/sharedComponents/Typography/Text";

import { FilterName } from "./TransitionProposalFlowSteps/Review/types";

export type TransitionProposalsTableColumnValue =
  | "name"
  | "status"
  | "updatedAt"
  | "action";

export enum TransitionProposalFlowPageIndex {
  Start = 0,
  Add = 1,
  Review = 2,
  Share = 3,
}

export interface CreateProposalButtonAction {
  title: string;
  description: string;
  type: TransitionProposalsImportTypeKey;
}

export interface TransitionProposalFlowStateData {
  importType: TransitionProposalsImportTypeKey;
  resources: SharedResource[];
  holdingsFilters: TransitionProposalHoldingsFilterResponse;
  documentPreviewFilterClicked: boolean;
  appliedFilter?: FilterName;
  filterSearchTerm?: string;
  showCustomPortfolioModal: boolean;
  hasTransitionProposalDetailsError?: boolean;
}

export interface ActionMenuItem {
  label: string;
  value: MenuActions;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  textColor?: TextColor;
  isDisabled?: boolean;
  isCloseOnClick: boolean;
}

export enum MenuActions {
  Share = "share",
  Rename = "rename",
  Duplicate = "duplicate",
  Delete = "delete",
}
